import MayoLanding from "../common/MayoLanding";

import doctorImage from "../../../../assets/Mayo/lp_img.png";

export default function MayoLanding1() {
  return <MayoLanding
    title={"Welcome"}
    text={"Prior to your TAVR clinic visit, it’s important for us that you’ll receive all the essential information, to ensure a comfortable experience. taking the first step toward heart health is significant, we assure you that you’re in good hands."}
    image={doctorImage}
    buttonText={"Let's start"}
    navigateTo={"/patient/mayo/choose-avatar"}
    postAnalyticType="messageOpned"
  />
}